import BannerAvisoMFA from "assets/images/banner-aviso-mfa.png";
import BannerIncentivoBoletoDigital from "components/BannerIncentivoBoletoDigital";
import BannerNovoAcessoBoleto from "components/BannerNovoAcessoBoleto";
import BannerPesquisaUsabilidade from "assets/images/banner-pesquisa-usabilidade.jpg";
import { ConfigPromotionsModel } from "./types";
import { TYPE_PROMOTION } from "./enums";

export const config: ConfigPromotionsModel[] = [
  {
    type: TYPE_PROMOTION.NPS,
    title: "Gostaríamos de entender sua experiência como cliente Ultragaz.",
    subTitle: "É simples, apenas 1 pergunta!",
    linkPromotion: "",
    dinamicLinkPromotion: true,
    localStorageKey: "closeBannerNPS",
    start: new Date(2024, 10, 27, 0, 0, 0),
    end: new Date(2024, 11, 16, 23, 59, 59),
    buttonLink: false,
  },
  {
    type: TYPE_PROMOTION.PESQUISA_USABILIDADE,
    start: new Date(2023, 8, 1, 0, 0, 0),
    end: new Date(2023, 10, 10, 23, 59, 59),
    img: BannerPesquisaUsabilidade,
    linkPromotion:
      "https://docs.google.com/forms/d/1-tF--s98IBLga9McPtCQMJzIuH9q8cYDd1c1KFqfd94/edit?usp=sharing_eip_m&ts=6511c9ad&sh=jxXDcaV_aEgqGqLq&ca=1",
    localStorageKey: "closeBannerPesquisaUsabilidade",
    buttonLink: false,
  },
  {
    type: TYPE_PROMOTION.INCENTIVO_BOLETO_DIGITAL,
    CustomModalComponent: BannerIncentivoBoletoDigital,
    buttonLink: false,
  },
  {
    type: TYPE_PROMOTION.NOVA_FORMA_ACESSO_BOLETO,
    end: new Date(2024, 2, 31, 23, 59, 59),
    CustomModalComponent: BannerNovoAcessoBoleto,
    localStorageKey: "closeBannerNovoAcessoBoleto",
    buttonLink: false,
  },
  {
    type: TYPE_PROMOTION.AVISO_MFA,
    img: BannerAvisoMFA,
    linkPromotion:
      "https://www.ultragaz.com.br/atencao-moradores-de-condominio-e-lojistas/",
    localStorageKey: "closeBannerAvisoMFA",
    buttonLink: false,
    customHeight: "600px",
    customWidth: "600px",
  },
];
